
function TableFallbackError() {
    return(
        <div className="col-span-12 h-[300px] rounded-lg border-[2px] border-red-300 bg-red-100 flex items-center justify-center pl-12 pr-12">
            <h2 className="font-semibold text-red-600">There was an error rendering the charger table. Try refreshing the page.</h2>
        </div>
    )
}

export default TableFallbackError